import { ErrorHandler, Injector } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { Injectable } from '@angular/core';
import { SispacError } from './sispac-error';

export class SispacErrorHandler implements ErrorHandler {

    handleError(error: SispacError) {
        console.log(error);
        //alert('Um erro inesperado aconteceu. Contate nosso suporte.');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/errors/sispac-error-handler.ts